<tt-page>
    <tt-grid [(ttOptions)]="grid"></tt-grid>
</tt-page>
